import { unsafeGet, Tag } from '../Context/dist/effect-Context.esm.js';
import { pipe } from '../Function/dist/effect-Function.esm.js';
import { globalValue } from '../GlobalValue/dist/effect-GlobalValue.esm.js';
import { tap, interruptFiber, map, flatMap, context, provideContext, asUnit } from './core.esm.js';
import { ignoreLogged } from './core-effect.esm.js';
import { acquireRelease, forkDaemon } from './fiberRuntime.esm.js';
import { scoped, build } from './layer.esm.js';
import { schedule_Effect } from './schedule.esm.js';
import { get as get$1, fromAcquire, set } from './scopedRef.esm.js';

/** @internal */
const ReloadableSymbolKey = "effect/Reloadable";

/** @internal */
const ReloadableTypeId = /*#__PURE__*/Symbol.for(ReloadableSymbolKey);

/** @internal */
const reloadableVariance = {
  _A: _ => _
};

/** @internal */
const auto = (tag, options) => scoped(reloadableTag(tag), pipe(build(manual(tag, {
  layer: options.layer
})), map(unsafeGet(reloadableTag(tag))), tap(reloadable => acquireRelease(pipe(reloadable.reload(), ignoreLogged, schedule_Effect(options.schedule), forkDaemon), interruptFiber))));

/** @internal */
const autoFromConfig = (tag, options) => scoped(reloadableTag(tag), pipe(context(), flatMap(env => pipe(build(auto(tag, {
  layer: options.layer,
  schedule: options.scheduleFromConfig(env)
})), map(unsafeGet(reloadableTag(tag)))))));

/** @internal */
const get = tag => flatMap(reloadableTag(tag), reloadable => get$1(reloadable.scopedRef));

/** @internal */
const manual = (tag, options) => scoped(reloadableTag(tag), pipe(context(), flatMap(env => pipe(fromAcquire(pipe(build(options.layer), map(unsafeGet(tag)))), map(ref => ({
  [ReloadableTypeId]: reloadableVariance,
  scopedRef: ref,
  reload: () => pipe(set(ref, pipe(build(options.layer), map(unsafeGet(tag)))), provideContext(env))
}))))));

/** @internal */
const tagMap = /*#__PURE__*/globalValue( /*#__PURE__*/Symbol.for("effect/Reloadable/tagMap"), () => new WeakMap([]));

/** @internal */
const reloadableTag = tag => {
  if (tagMap.has(tag)) {
    return tagMap.get(tag);
  }
  const newTag = Tag();
  tagMap.set(tag, newTag);
  return newTag;
};

/** @internal */
const reload = tag => flatMap(reloadableTag(tag), reloadable => reloadable.reload());

/** @internal */
const reloadFork = tag => flatMap(reloadableTag(tag), reloadable => pipe(reloadable.reload(), ignoreLogged, forkDaemon, asUnit));

export { ReloadableTypeId, auto, autoFromConfig, get, manual, reload, reloadFork, reloadableTag };
